<app-navbar />
<div class="layout-row">
  @if (!appSidebar.hidden) {
    <app-sidebar [class.collapsed]="appSidebar.collapsed" />
  }
  <div class="layout-content" (click)="collapseSidebar()">
    <div
      class="animate-view"
      [@routeChanging]="isRouteChanging"
      [@.disabled]="prefersReducedMotion"
    >
      <router-outlet />
    </div>
    <div [hidden]="!isRouteChanging">
      <spinner-icon />
    </div>
  </div>
</div>
<uploader-panel />
